import { defineComponent, PropType } from 'vue';
import { DefaultReportModel, MGA_REPORT_TABLE_COLUMNS, ReportTableHeaders } from '@/models/report/report.model';

export default defineComponent({
  name: 'MgaTotalList',
  props: {
    totalText: {
      type: String,
      default: 'Total',
    },
    totalReport: {
      type: Object as PropType<DefaultReportModel>,
      required: true,
    },
  },
  setup() {
    return {
      MGA_REPORT_TABLE_COLUMNS,
      ReportTableHeaders,
    };
  },
});
